<div class="header">
  <div class="left">
    <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </div>

  <div class="right">
    <span class="user-name" *ngIf="identity">
      {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
    </span>
    <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity">
      <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openPerfil()">
        <mat-icon matBadgeColor="warn">person</mat-icon> Mi perfil
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
      </button>
    </mat-menu>
    <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
      <mat-icon class="icon">home</mat-icon>
    </button>
  </div>
</div>


<div class="container">

  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div mat-card-avatar class="example-header-image"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="title1b">Validación de Certificados Digitales</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
          <p>Dirección de Obras Municipales</p>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="row">

        <div class="rol-div">
          <h4 class="card-title">Código de Búsqueda</h4>
          <mat-form-field class="mat-field-rol">
            <input matInput type="text" placeholder="Código" [formControl]="cod" required>

          </mat-form-field>
        </div>


        <div class="btn-cont">
          <button color="primary" mat-raised-button (click)="buscar()"
            [disabled]="cod.status == 'INVALID'">Buscar</button>
        </div>

      </div>

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>
</div>